export default __webpack_public_path__ + "static/media/djpr.6bd021dd.jpg";